import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../components/default/header";
import SidebarMenu from "../../menu/sidebarMenu";
import Breadcrumb from "../../../default/breadcrumb/breadcrumb";
import SingleLeadCategoryData from "./leadSingleCatData";

const LeadSingleCategory = () => {
    return (
        <div className="business-wrapper sidebar-menu-enable">
            <Helmet>
                <title>Single Category</title>
            </Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <SingleLeadCategoryData />
                </div>
            </div>
        </div>
   )
}

export default LeadSingleCategory;